// src/pages/Cartas.js

import React, { useEffect, useState, useContext } from "react";
import { AuthContext } from "../contexts/AuthContext";
import { jwtDecode } from "jwt-decode";
import AdminLayout from "../components/AdminLayout";
import DataTableCartas from "../components/DataTableCartas";
import axios from "axios";

function Cartas() {
  axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL;
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const { user: contextUser } = useContext(AuthContext);
  let user = contextUser;
  if (!user) {
    const tokenString = localStorage.getItem("authTokens");
    if (tokenString) {
      try {
        const tokens = JSON.parse(tokenString);
        if (tokens.access) {
          user = jwtDecode(tokens.access);
        }
      } catch (error) {
        console.error("Erro ao decodificar o token:", error);
      }
    }
  }
  const isAdmin = user && user.group && user.group.includes("admin");

  // Função para buscar os dados das cartas
  const fetchData = () => {
    axios.get("cartas/")
      .then(response => {
        setData(response.data);
        setLoading(false);
      })
      .catch(error => {
        console.error("Erro ao buscar dados das cartas:", error);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <AdminLayout>
      <DataTableCartas
        title="Cartas"
        newButtonRoute="./novo"
        excelButtonRoute={`${process.env.REACT_APP_API_BASE_URL}cartas/export/`}
        data={data}
        onUpdate={fetchData}
        isAdmin={isAdmin}
      />
    </AdminLayout>
  );
}

export default Cartas;